import 'css-chunk:../components/button/index.module.scss';export default {
  "button": "_button_89op9_1",
  "primary": "_primary_89op9_24",
  "disabled": "_disabled_89op9_38",
  "block": "_block_89op9_44"
};